import { Component, Event, EventEmitter, h, Prop } from '@stencil/core';
import { MileageOption, PriceCalculation } from '../../../types/types';
import { formatPrice, t } from '../../../redux/utils';
import { getMileageAmountPerPeriod } from '../../../utils/mileage';

@Component({
  tag: 'rentware-cart-mileage',
  styleUrl: 'style.sass',
  shadow: true,
})
export class RentwareCartMileage {
  @Event() valueChange: EventEmitter;
  @Prop() mileageOptions: MileageOption[];
  @Prop() value: string = '';
  @Prop() quantity: number = 0;
  @Prop() isWaiting = false;

  handleOptionChange = e => {
    e.stopPropagation();
    e.preventDefault();
    this.valueChange.emit(e.detail.value);
  };

  getMileagePrice(price, period: string = PriceCalculation.Interval) {
    const selectedPrice = price?.gross;

    if (selectedPrice === undefined || selectedPrice === null) {
      return null;
    } else if (selectedPrice === 0 || selectedPrice === '0') {
      return t('units.included');
    } else {
      const isRelative = period !== PriceCalculation.Interval;
      if (!isRelative) {
        return formatPrice(selectedPrice, '+');
      }

      const mileagePeriod = t('units.' + period);
      const sign = '/';

      return formatPrice(selectedPrice, '+') + sign + mileagePeriod;
    }
  }

  get options() {
    return (
      (this.mileageOptions &&
        this.mileageOptions.map(item => {
          const labelPrice = this.getMileagePrice(item.relativePrice.price, item.relativePrice.calculationType);
          const info = (item.price.gross > 0 && `${this.quantity}x ${labelPrice}`) || t('article.mileageOptionZeroPrice');
          const label = getMileageAmountPerPeriod(item.relativeAmount.amount, item.config.includedAmount, item.relativeAmount.calculationType, t, item.config.unit);

          return {
            label: label,
            value: item.id,
            info: info,
          };
        })) ||
      []
    );
  }

  render() {
    return (
      <div class='MileageContainer'>
        <rentware-cart-mileage-list options={this.options} value={this.value} onValueChange={this.handleOptionChange} />

        {this.isWaiting && <div class='Waiting' />}
      </div>
    );
  }
}
